import { Helmet } from 'react-helmet';
import TilebatsoDetail
  from 'src/components/tilebatso-detail/TilebatsoDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import TilebatsoListToolbar from '../components/tilebatso-detail/TilebatsoListToolbar';

const TilebatsoList = () => (
  <>
    <Helmet>
      <title>Tỉ lệ bắt số</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <TilebatsoListToolbar />
        <Box sx={{ pt: 3 }}>
          <TilebatsoDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default TilebatsoList;
